import styled from 'styled-components';

export const PatientPortalFormContainerStyles = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;
